/*
* Copyright (C) Regione Lombardia
*/
export const CoreAppConfigs = {
    NAME_DESKTOP: 'ODS - Opere di Difesa del Suolo',
    NAME_MOBILE: 'ODS - Opere di Difesa del Suolo',
    VERSION: '1.0.0'
};
